import axiosInstance from "./axios";

export const CSVData = async (param) =>
  axiosInstance.get(`/api/v1/get-csv/${param}`);
